module.exports = __webpack_public_path__ + "img/star-w.e99649c2.svg";